import React, { useState } from 'react';
import { Modal, Typography } from 'antd';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import './initiateReturn.scss';
import RadioFieldInput from '../../CustomComponents/RadioField/RadioFieldInput';
import { initiatePickup } from 'store/actions/IssuePanelActions';
import { connect } from 'react-redux';

const { Text } = Typography;

const InitiateReturnModal = ({ 
  record,
  initiateReturnModalVisible, 
  setInitiateReturnModalVisible, 
  setToastVisible,
  setToastText, 
  initiatePickup,
  activeIssueData,
}) => {
  const allOptions = [
    { id: '1', name: 'Return to supplier' },
    { id: '2', name: 'Add to inventory' },
  ];

  const fabricName = record?.fabricName?.toLowerCase() || '';

  const options = fabricName.includes("blends")
    ? allOptions.filter(option => option.id !== '2')
    : allOptions;

  const handleSubmit = (values) => {
    const METER_TO_YARD = 1.093;
    const quantity = (record.isInternational 
      ? Number(((+record.totalQuantity) * METER_TO_YARD).toFixed(2))
      : (+record.totalQuantity)
    );
    const inputs = {
      orderId: record.orderId,
      quantity: quantity,
      returnType: +values.returnType,
    }

    initiatePickup(inputs)
    .then(res => {
      if (res.success) {
        setToastText('Return initiated successfully!');
        setToastVisible(true);
        setInitiateReturnModalVisible(!initiateReturnModalVisible);
      }
    });
  };

  return (
    <Formik
      initialValues={{ returnOption: '' }}
      validationSchema={Yup.object({
        returnOption: Yup.string().required('Please select an option'),
      })}
      onSubmit={handleSubmit}>
      {({ setFieldValue, values, errors, touched }) => (
        <Modal
          title={<span style={{ fontWeight: 'bold', fontSize: '18px' }}>Initiate Return</span>}
          open={initiateReturnModalVisible}
          onCancel={() => setInitiateReturnModalVisible(!initiateReturnModalVisible)}
          footer={null}
          centered
          className="return-modal"
          bodyStyle={{
            height: '220px',
          }}>
          <Text className="modal-text">
            Please select the delivery location for the goods that will be picked up from the
            customer:
          </Text>
          <Form>
            <div className="radio-group">
              <RadioFieldInput
                name="returnType"
                label=""
                isRequired
                options={options}
                onSelect={(value) => setFieldValue('returnOption', value)}
                isMultipleAllowed={false}
              />
            </div>

            {touched.returnOption && errors.returnOption && (
              <div className="error-message">{errors.returnOption}</div>
            )}

            <div className="modal-footer">
              <button
                type="button"
                className="close-btn"
                onClick={() => setInitiateReturnModalVisible(false)}>
                Close
              </button>
              <button type="submit" className="submit-btn" disabled={!values.returnOption}>
                Submit
              </button>
            </div>
          </Form>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = (state) => ({
  activeIssueData: state.issuePanelData.activeIssueData,
});

const mapDispatchToProps = (dispatch) => ({
  initiatePickup: (data) => dispatch(initiatePickup(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InitiateReturnModal);
